import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '..';
import { getActiveComponentDesign } from './getActiveComponentDesignSelector';

export const getActiveDimensionSet = createSelector(
  (state: RootState) => state.dimensions.sets,
  getActiveComponentDesign,
  (dimensionSets, activeComponentDesign) =>
    activeComponentDesign ? dimensionSets[activeComponentDesign.dimensionSetGuid] : undefined,
);
